import { requestWithPromise } from '..'
import { getDataOrDefault, HttpMethods } from '../apiHelper'

export const getAllLanguages = () => {
  return requestWithPromise(
    '/public/languages',
    HttpMethods.GET,
    null,
    null
  ).then(getDataOrDefault([]))
}
